export const experienceData = [
    {
        id: 1,
        company: 'Hitachi Construction Machinery',
        jobtitle: 'Senior Platform & DevOps Engineer',
        startYear: '2024',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'DXC Technology',
        jobtitle: 'Infrastructure Systems Engineer',
        startYear: '2021',
        endYear: '2024'
    },
    {
        id: 3,
        company: 'Aurecon',
        jobtitle: 'Graduate Software Engineer',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 4,
        company: 'Origin Energy',
        jobtitle: 'Intern Data Engineer',
        startYear: '2018',
        endYear: '2019'
    },
]